import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export interface RelatedLink {
  readonly to: string
  readonly title: string
  readonly description: string
}

interface RelatedLinksProps {
  readonly heading: string
  readonly links: readonly RelatedLink[]
}

/** Internal-link card grid used to cross-link pillar ↔ compare ↔ use-case pages. */
export function RelatedLinks({ heading, links }: RelatedLinksProps) {
  const { t } = useTranslation()

  return (
    <section className="mx-auto max-w-5xl px-6 py-16">
      <h2 className="text-2xl font-bold tracking-tight text-foreground sm:text-3xl">{heading}</h2>
      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {links.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="glass-card glass-hover group flex flex-col rounded-2xl p-6 no-underline"
          >
            <h3 className="text-base font-semibold text-foreground">{link.title}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground">
              {link.description}
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary">
              {t('marketing.common.readMore')}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  )
}
